import { toIsoDateLocal } from './formatters';

/** The booking calendar's selectable window: `minIso` (today) and `maxIso`
 *  (`windowDays` days ahead). "Today" is `now`'s LOCAL calendar day
 *  (`toIsoDateLocal`), never `now.toISOString()`, which is the UTC day and
 *  reads as tomorrow for an evening guest west of UTC. Shared by every
 *  booking calendar so none can drift on how "today" is derived
 *  (standards B.7). */
export interface CalendarWindow {
  minIso: string;
  maxIso: string;
}

export function resolveCalendarWindow(now: Date, windowDays: number): CalendarWindow {
  const minIso = toIsoDateLocal(now);
  const upperBound = new Date(now);
  upperBound.setDate(upperBound.getDate() + windowDays);
  return { minIso, maxIso: toIsoDateLocal(upperBound) };
}
